import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import Typography from '../../../components/Basics/Typography'
import Spinner from '../../../components/Spinners/Spinner'
import CaseStudySections from './CaseStudySections'
import { findProjectBySlug, PROJECT_KINDS, resolveDetailHero } from './project.model'
import { onGetProjectsAsync } from './Project.slice'
import {
  BackLink,
  Container,
  ExternalLink,
  HeroImage,
  Links,
  Meta,
  NotFound,
  Summary,
  TechStack,
  TechTag,
} from './ProjectDetail.styles'

const ProjectDetail = () => {
  const { slug } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { error, loading, projects } = useSelector((state) => state.projects)

  const project = findProjectBySlug(projects, slug)

  useEffect(() => {
    dispatch(onGetProjectsAsync())
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleBack = () => {
    const sectionId =
      project?.kind === PROJECT_KINDS.PRACTICE ? 'practice' : 'projects'
    navigate(`/#${sectionId}`)
  }

  if (loading && !project) {
    return (
      <Container>
        <Spinner />
      </Container>
    )
  }

  if (!loading && !project) {
    return (
      <Container>
        <BackLink onClick={handleBack}>← Back to projects</BackLink>
        <NotFound>
          <Typography variant="h3">Project not found</Typography>
          <Typography variant="body2">
            {error ? 'There was an error loading projects.' : 'This case study does not exist.'}
          </Typography>
        </NotFound>
      </Container>
    )
  }

  const { caseStudy, links, role, technologies, year } = project
  const hero = resolveDetailHero(project)

  return (
    <Container>
      <BackLink onClick={handleBack}>← Back to projects</BackLink>

      <Typography variant="h1">{hero.title}</Typography>

      <Meta>
        <span>{role}</span>
        {year && <span>{year}</span>}
      </Meta>

      {hero.subtitle && <Summary>{hero.subtitle}</Summary>}

      {technologies.length > 0 && (
        <TechStack>
          {technologies.map((tech) => (
            <TechTag key={tech}>{tech}</TechTag>
          ))}
        </TechStack>
      )}

      {links.length > 0 && (
        <Links>
          {links.map((link) => (
            <ExternalLink
              key={link.url}
              href={link.url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {link.label}
            </ExternalLink>
          ))}
        </Links>
      )}

      {hero.cover && (
        <HeroImage>
          <img alt={hero.title} src={hero.cover} />
        </HeroImage>
      )}

      <CaseStudySections sections={caseStudy.sections} />
    </Container>
  )
}

export default ProjectDetail
